
/* titular char por char */
(function(){
  var lines=['TU ENERGÍA','A LOS 40 NO','ES LA DE LOS|60'];
  var mh=document.getElementById('mh'); var html='';
  lines.forEach(function(ln,li){ html+='<span class="ln">'; ln.split('').forEach(function(ch,ci){ var coral=false; if(ln.indexOf('|')>-1){ if(ch==='|'){return;} } 
    var isC=(li===2 && ci>=ln.indexOf('|')); var disp=ch===' '?'&nbsp;':ch; html+='<span class="ch'+(isC?' c':'')+'" style="animation-delay:'+(li*0.08+ci*0.03)+'s">'+disp+'</span>'; }); html+='</span>'; });
  mh.innerHTML=html;
})();
/* reveals robustos */
var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.15});
document.querySelectorAll('.reveal').forEach(function(el){io.observe(el);});
/* tilt 3D del bote con el raton */
(function(){ var p=document.querySelector('#prod img'); if(!p)return;
  addEventListener('mousemove',function(e){ var rx=(e.clientY/innerHeight-.5)*-16, ry=(e.clientX/innerWidth-.5)*22; p.style.transform='rotateX('+rx+'deg) rotateY('+ry+'deg)'; });
})();
/* funciona horizontal scroll (sin gsap: traduce el track segun progreso de scroll del pin) */
(function(){ var pin=document.querySelector('.hpin'), track=document.getElementById('htrack'); if(!pin||!track)return;
  function upd(){ var r=pin.getBoundingClientRect(); var total=pin.offsetHeight-innerHeight; var prog=Math.min(1,Math.max(0,-r.top/total)); var max=track.scrollWidth-innerWidth+ innerWidth*0.06; track.style.transform='translateX('+(-prog*max)+'px)'; }
  addEventListener('scroll',upd,{passive:true}); addEventListener('resize',upd); upd();
})();
/* ===== HERO: shader WebGL reactivo al raton (mesh-gradient fluido + ondas) ===== */
(function(){
  var canvas=document.getElementById('gl'); if(!canvas||!window.THREE)return;
  var ren=new THREE.WebGLRenderer({canvas:canvas,antialias:false}); ren.setPixelRatio(Math.min(devicePixelRatio,1.5));
  var scene=new THREE.Scene(); var cam=new THREE.OrthographicCamera(-1,1,1,-1,0,1);
  var mouse=new THREE.Vector2(.5,.5), tMouse=new THREE.Vector2(.5,.5);
  var uni={ uTime:{value:0}, uRes:{value:new THREE.Vector2(1,1)}, uMouse:{value:new THREE.Vector2(.5,.5)} };
  var frag=[
  'precision highp float;',
  'uniform float uTime; uniform vec2 uRes; uniform vec2 uMouse; varying vec2 vUv;',
  'vec3 NAVY=vec3(0.039,0.086,0.157); vec3 BURG=vec3(0.784,0.271,0.357); vec3 CORAL=vec3(0.878,0.443,0.373); vec3 GOLD=vec3(0.878,0.690,0.384);',
  'vec2 hash(vec2 p){ p=vec2(dot(p,vec2(127.1,311.7)),dot(p,vec2(269.5,183.3))); return -1.0+2.0*fract(sin(p)*43758.5453123); }',
  'float noise(vec2 p){ vec2 i=floor(p),f=fract(p); vec2 u=f*f*(3.0-2.0*f);',
  ' return mix(mix(dot(hash(i+vec2(0.0,0.0)),f-vec2(0.0,0.0)),dot(hash(i+vec2(1.0,0.0)),f-vec2(1.0,0.0)),u.x),',
  '            mix(dot(hash(i+vec2(0.0,1.0)),f-vec2(0.0,1.0)),dot(hash(i+vec2(1.0,1.0)),f-vec2(1.0,1.0)),u.x),u.y); }',
  'float fbm(vec2 p){ float v=0.0,a=0.5; for(int i=0;i<5;i++){ v+=a*noise(p); p*=2.0; a*=0.5; } return v; }',
  'void main(){',
  ' vec2 uv=vUv; float asp=uRes.x/uRes.y; vec2 p=uv; p.x*=asp;',
  ' vec2 m=uMouse; m.x*=asp;',
  ' float t=uTime*0.06;',
  ' vec2 q=vec2(fbm(p*1.6+t), fbm(p*1.6+vec2(5.2,1.3)-t));',
  ' float n=fbm(p*1.7 + q*1.6 + t); n=clamp(n*0.62+0.5,0.0,1.0);',
  ' float d=distance(p,m);',
  ' float ripple=sin(d*16.0 - uTime*2.2)*exp(-d*3.2)*0.18;',
  ' n+=ripple + (0.12*exp(-d*2.5));',
  ' vec3 col=mix(NAVY,BURG,smoothstep(0.5,0.86,n));',
  ' col=mix(col,CORAL,smoothstep(0.74,0.93,n)*0.85);',
  ' col=mix(col,GOLD,smoothstep(0.9,1.0,n)*0.5);',
  ' col=mix(col,NAVY*0.6,smoothstep(0.0,0.15,uv.y)*0.0);',
  ' col*= 0.78+0.22*smoothstep(0.2,0.85,n);',
  ' gl_FragColor=vec4(col,1.0);',
  '}'].join('\n');
  var mat=new THREE.ShaderMaterial({ uniforms:uni, vertexShader:'varying vec2 vUv; void main(){ vUv=uv; gl_Position=vec4(position,1.0); }', fragmentShader:frag });
  scene.add(new THREE.Mesh(new THREE.PlaneGeometry(2,2),mat));
  function resize(){ var w=canvas.clientWidth,h=canvas.clientHeight; ren.setSize(w,h,false); uni.uRes.value.set(w,h); }
  addEventListener('resize',resize); resize();
  addEventListener('mousemove',function(e){ var r=canvas.getBoundingClientRect(); tMouse.set((e.clientX-r.left)/r.width, 1.0-(e.clientY-r.top)/r.height); });
  var vis=true; new IntersectionObserver(function(es){vis=es[0].isIntersecting;}).observe(canvas);
  var clock=new THREE.Clock();
  (function loop(){ requestAnimationFrame(loop); if(!vis)return; uni.uTime.value=clock.getElapsedTime();
    mouse.lerp(tMouse,0.06); uni.uMouse.value.copy(mouse); ren.render(scene,cam); })();
})();
